import {createApi} from '@reduxjs/toolkit/dist/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {BexioAccountSearchRequest, PageBexioAccountDTO} from 'src/types/bexioAccounts';
import {getBaseURL} from 'src/utils/helper';

export const bexioAccountsApi = createApi({
    reducerPath: 'bexioAccountsApi',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({
        baseUrl: String(getBaseURL() + '/bexioAccounts'),
    }),
    tagTypes: ['BexioAccount'],
    endpoints: (build) => {
        return {
            searchBexioAccounts: build.query<PageBexioAccountDTO, BexioAccountSearchRequest>({
                query: ({data, params}) => ({
                    url: '/search',
                    method: 'post',
                    data,
                    params,
                }),
                providesTags: ['BexioAccount'],
            }),
        };
    },
});